(function () {
  'use strict';

  var source = document.currentScript && document.currentScript.src || '';

  function asset(name) {
    return source.replace(/jjt-on-cart-system-v2\.js(?:\?.*)?$/, name + '?v=' + Date.now());
  }

  function loadCss(name) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = asset(name);
    document.head.appendChild(link);
  }

  function loadScript(name, done) {
    var script = document.createElement('script');
    script.src = asset(name);
    script.async = false;
    script.onload = done || function () {};
    document.body.appendChild(script);
  }

  function start() {
    loadCss('jjt-core-belt-on.css');
    loadScript('jjt-core-belt-flow.js', function () {
      loadScript('jjt-on-cart-system-v2-base.js');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
